export default {
  back: 'Back to campaigns',
  title: 'Campaign',
  sent_at: 'Sent {{time}}',
  breakdown_title: 'Delivery summary',
  pending_receipts: {
    title: 'Delivery stats are on their way',
    description:
      'This campaign was just sent. Push providers confirm delivery about 15 minutes after send, so the numbers below will fill in around {{time}} — no action needed.',
    countdown:
      'Apple and Google confirm receipts in about {{minutes}}m {{seconds}}s (around {{time}}). The stats will refresh automatically.',
    ready: 'Receipts should be in. The numbers below are refreshing now.',
    soon: 'shortly',
  },
  recipients: {
    title: 'Recipients',
    subtitle: 'Who this campaign was sent to and whether it reached their device.',
    filters: {
      all: 'All',
      delivered: 'Delivered',
      pending: 'Awaiting confirmation',
      failed: 'Not delivered',
    },
    columns: {
      recipient: 'Recipient',
      status: 'Status',
      reason: 'Reason',
      clicked: 'Clicked',
      sent_at: 'Sent at',
    },
    status: {
      delivered: 'Delivered',
      pending: 'Awaiting confirmation',
      failed: 'Not delivered',
    },
    reasons: {
      DeviceNotRegistered: 'App removed or notifications turned off (expired token)',
      MessageRateExceeded: 'Temporarily rate-limited by Expo',
      MessageTooBig: 'Notification payload too large',
      MismatchSenderId: 'Push credentials mismatch',
      InvalidCredentials: 'Invalid push credentials',
      batch_failed: 'Send batch failed',
      missing_ticket: 'No confirmation returned by Expo',
      unknown: 'Unknown delivery error',
    },
  },
};
